const PRIORITY_PAGES = [
    () => import('../pages/Orders/Create'),
    () => import('../pages/Orders'),
    () => import('../pages/Catalogue'),
    () => import('../pages/Customers'),
    () => import('../pages/Invoices'),
];

const IDLE_TIMEOUT = 5000;
const FALLBACK_DELAY = 2000;

const isConstrainedConnection = (connection) =>
    !!connection && (!!connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ''));

const scheduleWhenIdle = (task) => {
    if ('requestIdleCallback' in window) {
        const id = window.requestIdleCallback(task, { timeout: IDLE_TIMEOUT });
        return () => window.cancelIdleCallback(id);
    }
    const id = setTimeout(task, FALLBACK_DELAY);
    return () => clearTimeout(id);
};

export const prefetchPages = ({
    loaders = PRIORITY_PAGES,
    connection = navigator.connection,
    schedule = scheduleWhenIdle,
} = {}) => {
    if (isConstrainedConnection(connection)) return () => {};

    let cancelled = false;
    const cancelSchedule = schedule(async () => {
        for (const load of loaders) {
            if (cancelled) return;
            try {
                await load();
            } catch (error) {
                // a failed prefetch only means the page loads on demand as before
            }
        }
    });

    return () => {
        cancelled = true;
        cancelSchedule?.();
    };
};
